import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  & > div {
    flex-shrink: 0;
  }
`;

export const Files = styled.div`
  flex: 1;
  border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
  margin-top: 1.5rem;
  overflow-y: auto;
`;

export const NoResultsMessage = styled.p`
  text-align: center;
`;

export const InputMessage = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textGrey};
  margin: 0;
  padding: 16px 0;
`;
